import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Cookie, ArrowLeft } from 'lucide-react';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-[#0A0F1C]">
      <Header />
      
      <div className="pt-40 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-[#2563EB] hover:text-[#3B82F6] mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>

          <div className="flex items-center gap-4 mb-8">
            <div className="w-14 h-14 bg-gradient-to-br from-[#2563EB] to-[#3B82F6] rounded-xl flex items-center justify-center">
              <Cookie className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-[#F8FAFC]">Cookie Policy</h1>
              <p className="text-[#94A3B8]">Last updated: January 2025</p>
            </div>
          </div>

          <div className="prose prose-invert prose-lg max-w-none">
            <div className="text-[#94A3B8] leading-relaxed space-y-6">
              <p className="text-lg">
                This Cookie Policy explains how PriceStrike uses cookies and similar technologies to recognize you when you visit our website.
              </p>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8 mt-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">What Are Cookies?</h2>
                <p>
                  Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used to make websites work more efficiently and provide information to website owners.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Types of Cookies We Use</h2>
                
                <h3 className="text-xl font-bold text-[#F8FAFC] mt-6 mb-3">Essential Cookies</h3>
                <p>
                  These cookies are necessary for the website to function and cannot be switched off. They are usually set in response to actions you take, such as setting privacy preferences or logging in.
                </p>

                <h3 className="text-xl font-bold text-[#F8FAFC] mt-6 mb-3">Analytics Cookies</h3>
                <p>
                  These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our website functionality.
                </p>

                <h3 className="text-xl font-bold text-[#F8FAFC] mt-6 mb-3">Functionality Cookies</h3>
                <p>
                  These cookies enable enhanced functionality and personalization, such as remembering your preferences and settings.
                </p>

                <h3 className="text-xl font-bold text-[#F8FAFC] mt-6 mb-3">Marketing Cookies</h3>
                <p>
                  These cookies track your online activity to help deliver more relevant advertising or to limit how many times you see an advertisement.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">How to Control Cookies</h2>
                <p>
                  You can control and manage cookies in various ways. Please note that removing or blocking cookies can impact your user experience and some functionality may no longer be available.
                </p>
                <p className="mt-4">
                  Most browsers automatically accept cookies, but you can modify your browser settings to decline cookies if you prefer. Instructions for managing cookies can be found in your browser's help section.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Third Party Cookies</h2>
                <p>
                  We may use third party services such as Google Analytics that also use cookies. These third parties have their own privacy policies and we have no control over their cookies.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Updates to This Policy</h2>
                <p>
                  We may update this Cookie Policy from time to time. We will notify you of any changes by posting the new policy on this page with an updated revision date.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#111827] to-[#0A0F1C] border border-[#2563EB]/30 rounded-xl p-8">
                <h2 className="text-2xl font-bold text-[#F8FAFC] mb-4">Contact Us</h2>
                <p>
                  If you have questions about our use of cookies, please contact us at:
                </p>
                <p className="mt-4">
                  Email: <a href="mailto:privacy@axiosera.com" className="text-[#2563EB] hover:text-[#3B82F6]">privacy@axiosera.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default CookiePolicy;
